import { render, staticRenderFns } from "./EditProductConfig.vue?vue&type=template&id=3a488616&scoped=true"
import script from "./EditProductConfig.vue?vue&type=script&lang=js"
export * from "./EditProductConfig.vue?vue&type=script&lang=js"
import style0 from "./EditProductConfig.vue?vue&type=style&index=0&id=3a488616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a488616",
  null
  
)

export default component.exports